module.exports = __webpack_public_path__ + "static/media/apple-app-store-badge.ab66db34.svg";